(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('FollowupStatus', FollowupStatus);

    FollowupStatus.$inject = ['$resource'];

    function FollowupStatus ($resource) {
        var resourceUrl =  'api/followup-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
